import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { convertPxToVw } from '../../utils';
let SingleCoup = class SingleCoup extends Vue {
    constructor() {
        super(...arguments);
        this.singleFail = false;
        this.timer = null;
        this.timeText = '';
    }
    get isFail() {
        if (this.isBag) {
            return ((this.bagFailList &&
                this.bagFailList.includes(this.info && this.info.coupon_id)) ||
                this.singleFail);
        }
        else {
            return this.singleFail;
        }
    }
    get realMargin() {
        return convertPxToVw(this.data.coupSingle.coupMargin);
    }
    get compMargin() {
        return convertPxToVw(this.data.coupSingle.compMargin);
    }
    get isEnd() {
        let isReceive = !!this.info.use_end_time;
        let isEnd = !!this.info.is_end;
        let isOverTime1 = this.info.end_time && this.toTimeStamp(this.info.end_time) < +new Date();
        let isOverTime2 = this.info.used_end_time &&
            this.toTimeStamp(this.info.used_end_time) < +new Date();
        return !isReceive && (isEnd || isOverTime1 || isOverTime2);
    }
    get isExpire() {
        let isUsed = !!this.info.used;
        let isOverTime = this.info.use_end_time &&
            this.toTimeStamp(this.info.use_end_time) < +new Date();
        return !isUsed && isOverTime;
    }
    get isEmpty() {
        let isReceive = !!this.info.use_end_time;
        let isNoStock = this.info.limit_count <= this.info.obtained_count;
        return !isReceive && isNoStock;
    }
    get isUsed() {
        let isUsed = !!this.info.used;
        return isUsed;
    }
    get isReceived() {
        let isReceive = !!this.info.use_end_time;
        return isReceive && !this.isExpire && !this.isUsed;
    }
    get isVip() {
        return this.info.coupon_type === 'vip';
    }
    mounted() {
        if (this.isEnd ||
            this.isExpire ||
            this.isEmpty ||
            this.isUsed ||
            this.isReceived ||
            !this.info.start_time)
            return;
        this.countDownHandle(this.info.start_time);
    }
    // 领取优惠券
    async receiveCoupon() {
        await env.init();
        if (!(await env.getIsLogin())) {
            return await env.login();
        }
        this.$emit('clickEvent', this.info);
        try {
            const { data: recRes } = await this.$axios.post('/api/goods/shop/market/microPage/acquireCoupon', {
                page_id: this.pageId,
                coupon_ids: [this.info.coupon_id],
                ...this.publicParams,
            });
            if (recRes.message &&
                recRes.message.not_receive &&
                recRes.message.not_receive.length > 0) {
                return this.$Toast(recRes.message.not_receive[0].err_msg);
            }
            this.$emit('updateCoupons');
        }
        catch (e) {
            this.singleFail = true;
        }
    }
    async jumpToDetail() {
        this.$emit('clickEvent', this.info);
        await new Promise(resolve => {
            setTimeout(resolve, 100);
        });
        if (env.type === 'ivydad') {
            env.commonJump(`ivydadreadtool://weex/coupon-use?couponType=${this.info.used_scope}&couponId=${this.info.coupon_id}`);
        }
        else {
            window.location.href = `${window.location.origin}/center/coupon/consumedCouponCourseList?couponId=${this.info.coupon_id}`;
        }
    }
    // 倒计时函数
    countDownHandle(end) {
        let endTime = +new Date(end.replace(/-/g, '/'));
        let nowTime = +new Date();
        let leftTime = (endTime - nowTime) / 1000;
        let that = this;
        function getTime(leftTime1, start_time) {
            if (leftTime1 > 86400 * 3) {
                that.timeText = `${start_time.replace(/-/g, '.').substr(0, 16)}开抢`;
            }
            else {
                let day = Math.floor(leftTime1 / 60 / 60 / 24);
                let hour = Math.floor((leftTime1 / 60 / 60) % 24);
                hour = hour < 10 ? '0' + hour : hour;
                let minute = Math.floor((leftTime1 / 60) % 60);
                minute = minute < 10 ? '0' + minute : minute;
                let second = Math.floor(leftTime1 % 60);
                second = second < 10 ? '0' + second : second;
                that.timeText = `距开抢：<span>${day > 0 ? day * 24 + +hour : hour}</span>:<span>${minute}</span>:<span>${second}</span>`;
            }
        }
        getTime(leftTime, end);
        if (!this.timer) {
            this.timer = setInterval(() => {
                leftTime -= 1;
                if (leftTime <= 0) {
                    clearTimeout(this.timer);
                    this.timeText = '';
                }
                getTime(leftTime, end);
            }, 1000);
        }
    }
    toTimeStamp(time) {
        return +new Date(time.replace(/-/g, '/'));
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], SingleCoup.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], SingleCoup.prototype, "info", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], SingleCoup.prototype, "publicParams", void 0);
tslib_1.__decorate([
    Prop({ default: () => [] })
], SingleCoup.prototype, "bagFailList", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], SingleCoup.prototype, "isBag", void 0);
tslib_1.__decorate([
    Prop()
], SingleCoup.prototype, "pageId", void 0);
SingleCoup = tslib_1.__decorate([
    Component
], SingleCoup);
export default SingleCoup;
